import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { History } from "lucide-react";
import { api } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";
import { Chip, EmptyState, PageHeader, Spinner } from "@/components/common";

const ENTITIES = [["", "All"], ["lead", "Leads"], ["property", "Properties"], ["task", "Tasks"], ["chat_message", "Chat"], ["expense", "Expenses"], ["deal", "Deals"], ["action_plan", "AI plans"], ["user", "Users"], ["settings", "Settings"]];
const ISO = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/;
const show = (v) => (v === null || v === undefined || v === "" ? "—" : Array.isArray(v) ? v.join(", ") : typeof v === "object" ? JSON.stringify(v) : ISO.test(String(v)) ? fmtDateTime(v) : String(v));

export default function ActivityPage() {
  const [entity, setEntity] = useState("");
  const { data = [], isLoading } = useQuery({
    queryKey: ["activity", entity],
    queryFn: async () => (await api.get("/activity", { params: entity ? { entity } : {} })).data,
  });
  return (
    <>
      <PageHeader title="Activity log" testid="activity-title" subtitle="Every create, edit and delete — who, what, old → new, when." />
      <div className="mb-4 flex gap-2 overflow-x-auto scrollbar-none">
        {ENTITIES.map(([k, l]) => <Chip key={k} active={entity === k} onClick={() => setEntity(k)} testid={`activity-filter-${k || "all"}`}>{l}</Chip>)}
      </div>
      {isLoading ? <Spinner /> : !data.length ? <EmptyState icon={History} title="No activity yet" testid="activity-empty" /> : (
        <div className="divide-y overflow-hidden rounded-2xl border bg-card" data-testid="activity-list">
          {data.map((a) => (
            <div key={a.id} className="p-4" data-testid={`activity-item-${a.id}`}>
              <div className="flex flex-wrap items-baseline justify-between gap-2">
                <p className="text-sm"><span className="font-semibold">{a.user_name}</span> <span className="text-muted-foreground">{a.action.replace("_", " ")}</span> {a.entity} · <span className="font-medium">{a.label}</span></p>
                <span className="text-xs text-muted-foreground">{fmtDateTime(a.at)}</span>
              </div>
              {Object.keys(a.changes || {}).length > 0 && (
                <div className="mt-2 space-y-1">
                  {Object.entries(a.changes).slice(0, 12).map(([k, c]) => (
                    <p key={k} className="break-words text-xs"><span className="num text-muted-foreground">{k}:</span> <span className="text-rose-600 line-through dark:text-rose-400">{show(c.old)}</span> → <span className="text-emerald-700 dark:text-emerald-400">{show(c.new)}</span></p>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </>
  );
}
